export enum FullStorySampleMode {
  Static = 'static',
  Dynamic = 'dynamic',
}
